<div fxLayout="column" class="vh-100">
    <div fxFlex="78px" class="p-20" fxLayoutAlign="space-between center" fxLayoutGap="12px">
        <div fxLayout="row" fxLayoutGap="12px">
            <button mat-stroked-button matBadge="1" matBadgeSize="small">
                <i class="font-size-20 fas fa-file-signature"></i>
                <span toggle-label>Document en attente de validation</span>
            </button>
            <button mat-stroked-button matBadge="5" matBadgeSize="small">
                <i class="font-size-20 fas fa-tshirt"></i>
                <span toggle-label>Reservation client</span>
            </button>
            <button mat-stroked-button matBadge="5" matBadgeSize="small">
                <i class="font-size-20 fas fa-file-prescription"></i>
                <span toggle-label>Document en attente de validation</span>
            </button>
        </div>
        <div>
            <button (click)="doOpenCaisse()" color="primary" mat-raised-button>Ouvrir la caisse</button>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div fxFlex [formGroup]="openFormGroup">
        <div class="p-20 pb-0" fxLayout="row wrap" fxLayoutGap="12px">

            <unilog-recherche recherche="avtperso" champsModel="Perso_Matricule" champsAffiche="Perso_Nom" formControlName="Perso_Matricule"
                appearance="outline" label="Vendeur" [ServerSideFiltering]="true"
                textErreur="Veuillez Entrer Vendeur valide" [showError]="true" [api]='api' placeholder="Vendeur">
            </unilog-recherche>


            <unilog-recherche recherche="Cash" champsModel="Cash_Code" champsAffiche="Cash_Code" appearance="outline"
                label="Caisse" [ServerSideFiltering]="true" textErreur="Veuillez Entrer Caisse valide" [showError]="true"
                [api]='api' placeholder="Caisse" formControlName="Cash_Code"></unilog-recherche>

            <!-- <unilog-recherche recherche="Sites" champsModel="Site_Code" champsAffiche="Site_Des" appearance="outline"
                label="Etablissement" [ServerSideFiltering]="true" textErreur="Veuillez Entrer Etablissement valide"
                [showError]="true" [api]='api' placeholder="Etablissement"></unilog-recherche> -->

        </div>
        <div class="px-20" fxLayout="row wrap" fxLayoutGap="12px">
            <mat-form-field appearance="outline">
                <mat-label>Fond de caisse</mat-label>
                <input formControlName="CashD_MOuverture" matInput placeholder="Fond de caisse" type="number">
                <span matSuffix>DT</span>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Montant d'alimentation</mat-label>
                <input formControlName="CashD_MAlimentation" matInput placeholder="Montant d'alimentation"
                    type="number">
                <span matSuffix>DT</span>
            </mat-form-field>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div fxFlex="56px" fxLayoutAlign="center center">
        <button mat-stroked-button>
            <i class="font-size-20 fas fa-cash-register"></i>
            <span toggle-label class="label">fas fa-cash-register</span>
        </button>
    </div>
</div>